import { render, staticRenderFns } from "./playerData.vue?vue&type=template&id=2599dc69&scoped=true"
import script from "./playerData.vue?vue&type=script&lang=js"
export * from "./playerData.vue?vue&type=script&lang=js"
import style0 from "./playerData.vue?vue&type=style&index=0&id=2599dc69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2599dc69",
  null
  
)

export default component.exports